module.exports = __webpack_public_path__ + "320c46fefdf6443a700671dfcf59401b.jpg";